// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-bar {
  position: fixed;
  bottom: 0; left: 0; right: 0;
  height: var(--status-bar-height);
  background: var(--accent);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  z-index: 100;
  font-size: 12px;
  color: #fff;
}

.status-bar-left { font-weight: 600; letter-spacing: 0.04em; }

.status-bar-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.status-bar-item { opacity: 0.9; }
.status-bar-project { font-weight: 600; }

@media (max-width: 768px), (hover: none) and (max-width: 1024px) { .status-bar { display: none; } }
`, "",{"version":3,"sources":["webpack://./src/components/layout/StatusBar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS,EAAE,OAAO,EAAE,QAAQ;EAC5B,gCAAgC;EAChC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA,mBAAmB,gBAAgB,EAAE,sBAAsB,EAAE;;AAE7D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,mBAAmB,YAAY,EAAE;AACjC,sBAAsB,gBAAgB,EAAE;;AAExC,mEAAmE,cAAc,aAAa,EAAE,EAAE","sourcesContent":[".status-bar {\n  position: fixed;\n  bottom: 0; left: 0; right: 0;\n  height: var(--status-bar-height);\n  background: var(--accent);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 10px;\n  z-index: 100;\n  font-size: 12px;\n  color: #fff;\n}\n\n.status-bar-left { font-weight: 600; letter-spacing: 0.04em; }\n\n.status-bar-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.status-bar-item { opacity: 0.9; }\n.status-bar-project { font-weight: 600; }\n\n@media (max-width: 768px), (hover: none) and (max-width: 1024px) { .status-bar { display: none; } }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
